import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleHDIShuttleDIYKit = () => {
  console.log('🎯 SimpleHDIShuttleDIYKit component loading');
  
  const product = findProductById("hdi-shuttle-diy-kit");
  
  if (!product) {
    console.error('Product not found:', "hdi-shuttle-diy-kit");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="hdi-shuttle-diy-kit"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleHDIShuttleDIYKit; 